// Monster Squad logomark — three-eyed monster crest. Sharp, geometric, timeless.
export const LogoMark = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Monster Squad"
  >
    <rect x="2" y="2" width="60" height="60" rx="2" fill="#0A0A0A" />
    <path d="M2 24 L62 24" stroke="#E60000" strokeWidth="3" />
    {/* eyes */}
    <circle cx="20" cy="36" r="5" fill="#FFFFFF" />
    <circle cx="32" cy="34" r="6" fill="#FFFFFF" />
    <circle cx="44" cy="36" r="5" fill="#FFFFFF" />
    <circle cx="20" cy="36" r="2" fill="#0A0A0A" />
    <circle cx="32" cy="34" r="2.4" fill="#0A0A0A" />
    <circle cx="44" cy="36" r="2" fill="#0A0A0A" />
    {/* fangs */}
    <path d="M22 50 L26 56 L30 50 Z" fill="#FFFFFF" />
    <path d="M34 50 L38 56 L42 50 Z" fill="#FFFFFF" />
    {/* tag */}
    <rect x="6" y="8" width="22" height="8" fill="#E60000" />
  </svg>
);

export const Logo = ({ inverted = false, size = 28 }) => (
  <div className="flex items-center gap-2.5" data-testid="brand-logo">
    <LogoMark size={size} />
    <div className="flex flex-col leading-none">
      <span className={`font-heading font-black tracking-tight text-[15px] ${inverted ? "text-white" : "text-black"}`}>
        MONSTER SQUAD
      </span>
      <span className={`font-mono text-[9px] tracking-[0.3em] ${inverted ? "text-white/60" : "text-black/50"}`}>
        INTELLIGENT MEDIA · NAS
      </span>
    </div>
  </div>
);
